module.exports = __webpack_public_path__ + "img/5-4.815e7253.png";